<template>
  <div>
    <div class="filters">
      <ElForm ref="form" class="elementui-common-form-styles" v-highlight label-width="0" inline>
        <ElFormItem>
          <ElSelect style="width: 120px" size="small" v-model="form.prev" @change="queryLineData">
            <ElOption
              v-for="item in displayItems"
              :key="item.value"
              :value="item.key"
              :label="item.label"
              :disabled="form.next === item.key"
            >
            </ElOption>
          </ElSelect>
        </ElFormItem>
        <span class="contrast">&emsp;对比&emsp;</span>
        <ElFormItem>
          <ElSelect style="width: 120px" size="small" v-model="form.next" @change="queryLineData">
            <ElOption
              v-for="item in displayItems"
              :key="item.value"
              :value="item.key"
              :label="item.label"
              :disabled="form.prev === item.key"
            >
            </ElOption>
          </ElSelect>
        </ElFormItem>
      </ElForm>
    </div>

    <div style="position: relative" v-loading="chartLoading">
      <div class="line-chart" style="width: 100%; height: 400px" ref="chartRef"></div>
    </div>
  </div>
</template>
<script>
import Echarts from 'echarts'
import moment from 'moment'
import getChartOptions from '../../consts/line-opts.js'
import { displayItems } from '../../consts/index.js'
import { getHomeLineData } from '@/api/dashboard.model'
export default {
  data() {
    return {
      chartInstance: null,
      chartLoading: false,
      form: {
        prev: 'amount',
        next: 'newRoleRate'
      }
    }
  },
  computed: {
    displayItems() {
      return displayItems
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    /**
     * @description: 查询图表数据
     */
    queryLineData() {
      const { dateType, dateRange, projectGroupOpIds } = this.$parent.filterObjects
      const params = {
        ...this.$parent.filterObjects,
        key: this.form.next,
        projectGroupOpIds: projectGroupOpIds.join(',')
      }
      if (dateType === 7) {
        const [start, end] = dateRange
        params.beginTime = moment(start).format('YYYY-MM-DD')
        params.endTime = moment(end).format('YYYY-MM-DD')
      }

      this.chartLoading = true

      Promise.all([getHomeLineData({ ...params, key: this.form.prev }), getHomeLineData(params)])
        .then((data) => {
          const [prev, next] = data || [{}, {}]
          const opts = {
            prev: {
              key: prev.key,
              name: this.displayItems.find((d) => d.key === prev.key).label,
              list: prev.list || []
            },
            next: {
              key: next.key,
              name: this.displayItems.find((d) => d.key === next.key).label,
              list: next.list || []
            }
          }
          this.chartInstance.setOption(getChartOptions(opts))
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
    },

    initChart() {
      this.chartInstance = Echarts.init(this.$refs.chartRef)
    }
  }
}
</script>
<style lang="scss" scoped>
.contrast {
  line-height: 32px;
  display: inline-block;
}
</style>
